<template>
  <div class="let-page-title">For rådgivere</div>
</template>

<style lang="scss"></style>
